export const GET_EVENT_TYPES = 'GET_EVENT_TYPES'

export const UPDATE_EVENT_TYPES = 'UPDATE_EVENT_TYPES'
export const UPDATE_EVENT_TYPES_SEARCH_INFO = 'UPDATE_EVENT_TYPES_SEARCH_INFO'
